export default {
  LOCALE_HTML: {
    'msg.detail': '自助问题詳情',
    'your.msg': '自助提交',
    'msg.record': '自助问题记录',
    'msg.success': '提交成功',
    'to.record': '前往自助问题記錄',
    'completed':'完成',
    'submit': '提交',
    'success.desc': '感謝您的迴響',
  }
}